import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AccountFields } from 'api/fields/fields';

const initialState: AccountFields = {
  accountId: null,
  accountName: null,
  objectType: 'TASK',
  fields: [],
};

const taskFieldsSlice = createSlice({
  name: 'taskFields',
  initialState,

  reducers: (create) => ({
    saveFields: create.reducer(
      (state, { payload }: PayloadAction<AccountFields>) => {
        return {
          ...state,
          ...payload,
        };
      },
    ),
  }),
});

export const taskFieldsReducer = taskFieldsSlice.reducer;
export const { saveFields } = taskFieldsSlice.actions;
export const stateName = taskFieldsSlice.name;
